(() => {
  /* Input and textareas have labels float above when focused */
  const floatLabelOnFocus = (label) => {
    const wrapper = label.parentElement;
    const input = wrapper.querySelector('input, textarea');

    if (input === null) return;

    input.addEventListener('focus', () => {
      label.classList.add('--active');
      input.placeholder = label.textContent;
    });

    input.addEventListener('blur', () => {
      if (input.value !== '') return;

      label.classList.remove('--active');
      input.placeholder = '';
    });
  };

  /* Select dropdowns' labels float once an item has been selected */
  const floatLabelOnSelect = (label) => {
    const wrapper = label.parentElement;
    const input = wrapper.querySelector('select');

    if (input === null) return;

    input.addEventListener('change', (e) => {
      if (e.target.value === '') {
        label.classList.remove('--active');
      } else {
        label.classList.add('--active');
      }
    });
  };

  const floatingLabels = () => {
    const labels = document.querySelectorAll('.form__floating-label');

    labels.forEach((label) => {
      floatLabelOnFocus(label);
      floatLabelOnSelect(label);
    });
  };
  floatingLabels();
})();
